<script>
import StatusAwareAtom from "../StatusAwareComponent.vue";

export default {
  name: "TimeCounter",
  extends: StatusAwareAtom,
  props: {
    time: {
      type: Number,
      required: true
    },
    showSeconds: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  watch: {
    time: {
      immediate: true,
      handler(newTime) {
        this.currentTime = newTime;
        this.updateTime();
      }
    },
    status(newStatus) {
      if (newStatus === this.statuses.working) {
        this.startTimer();
      } else {
        clearInterval(this.intervalId);
      }
    }
  },
  data() {
    return {
      currentTime: this.time,
      hours: "00",
      minutes: "00",
      seconds: "00",
      intervalId: null
    }
  },
  methods: {
    updateTime() {
      this.hours = String(Math.floor(this.currentTime / 3600)).padStart(2, '0');
      this.minutes = String(Math.floor((this.currentTime % 3600) / 60)).padStart(2, '0');
      this.seconds = String(this.currentTime % 60).padStart(2, '0');
    },
    startTimer() {
      this.intervalId = setInterval(() => {
        this.currentTime++;
        this.updateTime();
      }, 1000);
    }
  },
  mounted() {
    this.updateTime();
    if (this.status === this.statuses.working) {
      this.startTimer();
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  }
}
</script>

<template>
  <p class="time-counter">
    <span>{{ hours }}</span>:<span>{{ minutes }}</span>:<span v-if="showSeconds">{{ seconds }}</span>
  </p>
</template>

<style scoped>
.time-counter {
  display: flex;
  justify-content: center;
  align-items: center;
}

span {
  display: inline-block;
  width: 2ch;
  text-align: center;
  margin-right: 1px;
}
</style>
